// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  username: __t.string().primaryKey(),
  identity: __t.identity(),
  displayName: __t.string().name("display_name"),
  passwordHash: __t.string().name("password_hash"),
  isAdmin: __t.bool().name("is_admin"),
  createdAt: __t.timestamp().name("created_at"),
  seasonGenDone: __t.i64().name("season_gen_done"),
});
